var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnProductivitySoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-productivitysoftware",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(9.236 14.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 4.653)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(13.539 51.341)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(4.832)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(0 27.552)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(44.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(4.824 54.153)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(13.398 22.535)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn-deceptors",
    transform: "translate(23.464 25.756)",
    opacity: 0.995
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M1164.829,1349.113h-3.786l-.748-3.028h-9.875l-.748,3.028h-3.786a1.328,1.328,0,1,0,0,2.656h18.944a1.328,1.328,0,1,0,0-2.656Z",
    transform: "translate(-1138.074 -1317.117)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12332",
    "data-name": "Path 12332",
    d: "M1449.807,73.772s7.631-.163,8.99,5.4-2.718,13.407-1.568,18.312l3.554-4.251V73.609S1449.7,73.772,1449.807,73.772Z",
    transform: "translate(-1429.334 -71.127)",
    fill: "#00aafc",
    opacity: 0.104
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12333",
    "data-name": "Path 12333",
    d: "M1430.662,88.593s6.691,15.5,20.9,15.732h-21.366Z",
    transform: "translate(-1427.826 -79.347)",
    fill: "#00aafc",
    opacity: 0.104
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M1109,1075h-28.429a3.084,3.084,0,0,0-3.075,3.075v21.28a3.061,3.061,0,0,0,3.061,3.06h28.429a3.084,3.084,0,0,0,3.075-3.075v-21.28A3.07,3.07,0,0,0,1109,1075Zm-.026,21.205a1.742,1.742,0,0,1-1.742,1.742h-7.967a1.474,1.474,0,0,0-1.4,1.022,1.024,1.024,0,0,1-.975.71h-4.217a1.024,1.024,0,0,1-.975-.71,1.475,1.475,0,0,0-1.4-1.022h-7.96a1.754,1.754,0,0,1-1.749-1.749v-16.523a1.742,1.742,0,0,1,1.742-1.742h24.9a1.754,1.754,0,0,1,1.749,1.749Z",
    transform: "translate(-1077.5 -1075)",
    fill: "#007dba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12900",
    "data-name": "Path 12900",
    d: "M194.682,846.7a4.651,4.651,0,0,1,.12.746q.011,7.564.005,15.128v.652h1.257V862.7q0-4.472,0-8.944c0-.872.308-1.121,1.379-1.122q1.162,0,2.324,0c.989,0,1.322.268,1.323,1.066q0,4.472,0,8.944v.59h1.257v-.552q0-5.8,0-11.6c0-.844.316-1.1,1.336-1.106.817,0,1.633,0,2.449,0,.893,0,1.24.29,1.24,1.031q0,5.852,0,11.7v.53h1.257v-.521q0-2.479,0-4.958c0-.762.344-1.035,1.294-1.037.858,0,1.717-.006,2.575,0,.779.007,1.152.308,1.154.945.007,1.839,0,3.678,0,5.6a5.941,5.941,0,0,1,.928.012,2.109,2.109,0,0,1,.568.278c-.2.108-.387.223-.592.318a.69.69,0,0,1-.248,0q-9.7,0-19.407,0a7.311,7.311,0,0,1-.853-.1q0-8.539,0-17.078Z",
    transform: "translate(-187.322 -842.662)",
    fill: "#00aafc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnProductivitySoftware);
export default __webpack_public_path__ + "static/media/icn-productivity-software.004440f0335195e7bc2d5a567c1e68be.svg";
export { ForwardRef as ReactComponent };